<template>
    <modal
        v-bind="$attrs"
        :width="modalWidth"
        v-on="$listeners"
    >
        <template #title>
            <h3 class="text-main-2xl font-semibold text-gray-700">
                {{ $t('tooltip.reorder.dashboard.layout') }}
            </h3>
        </template>
        <div class="py-4">
            <DraggableList
                v-if="showDraggableList"
                :value="widgetGroups"
                group="widgets"
                @change="(ev) => onGroupListChange(ev)"
            >
                <div
                    v-for="(widgetGroup, index) in widgetGroups"
                    :key="index"
                    class="w-full flex justify-between items-center items my-1"
                >
                    <div
                        :style="getStyles"
                        class="widget-item p-1"
                    >
                        {{ widgetGroup.WidgetGroupTitle || `# ${widgetGroup.WidgetGroupID}` }}
                    </div>
                    <div class="flex cursor-pointer">
                        <IconDragAndDrop class="text-gray-500 hover:text-primary" />
                    </div>
                </div>
            </DraggableList>
        </div>
        <template #footer>
            <div class="main-bg-light border-t-2 border-gray-300 py-4 px-10 flex items-center justify-between">
                <cancel-button
                    class="mx-4"
                    @on-click="onCancel"
                />
                <confirm-button
                    :label="$t('common.save')"
                    icon="IconSave"
                    @on-click="onSubmit"
                />
            </div>
        </template>
    </modal>
</template>
<script>
import draggableEvents from '@/enum/draggableEvents'
import cloneDeep from 'lodash/cloneDeep'
import { widgetGroupTitleStyles } from '@/composables/globalData/useLayouts'

export default {
    components: {
        Modal: () => import('@/components/Common/Modal.vue'),
        DraggableList: () => import('@/components/Widgets/DraggableList.vue'),
        CancelButton: () => import('@/components/Common/Buttons/CancelButton.vue'),
        ConfirmButton: () => import('@/components/Common/Buttons/ConfirmButton.vue')
    },
    props: {
        widgetGroupList: {
            type: Array,
            default: () => [],
        },
    },
    data () {
        return {
            widgetGroups: [],
            modalWidth: '700px',
            showDraggableList: false
        }
    },
    computed: {
        getStyles () {
            return widgetGroupTitleStyles.value
        },
    },
    methods: {
        onSubmit () {
            this.updateGroupOrder()
            this.$emit('on-submit', this.widgetGroups)
        },
        updateGroupOrder () {
            this.widgetGroups.forEach((group, index) => {
                this.$set(group, 'Order', index)
            })
        },
        onGroupListChange (ev) {
            const eventData = ev[draggableEvents.MOVED]
            const { newIndex: newIndex, oldIndex: oldIndex } = eventData

            this.widgetGroups.splice(newIndex, 0, this.widgetGroups.splice(oldIndex, 1)[0])
        },
        onCancel () {
            this.$emit('on-cancel')
        }
    },
    watch: {
        widgetGroupList: {
            deep: true,
            immediate: true,
            handler (value) {
                this.widgetGroups = cloneDeep(value)
            },
        },
    },
    mounted () {
        this.$nextTick(() => {
            this.showDraggableList = true
        })
    }
}
</script>
<style lang="scss" scoped>
.items {
    @apply flex w-full p-2 shadow-base border;
    border-radius: 4px;
}
</style>
